import { Injectable } from '@jkhy/frontend-utils/di';
import { CountriesClient } from '@treasury/api/channel';

@Injectable()
export class CountriesService {
    constructor(private readonly countriesClient: CountriesClient) {}

    public async getAll() {
        return (await this.countriesClient.countriesGet()).data;
    }
}
